export const ordinaryAccount = roles => Array.isArray(roles) && roles.length === 1 && roles[0] === 'user'

export function maintenancePayload(form, superAdmin, originalRoles) {
  const data = { fullName: form.fullName }
  if (superAdmin) data.roles = form.roles
  if (superAdmin || ordinaryAccount(originalRoles)) {
    data.isDeactivate = form.isDeactivate
    data.isBlocked = form.isBlocked
    data.isVerifiedPhoneNumber = form.isVerifiedPhoneNumber
    if (form.newPassword) data.password = form.newPassword
  }
  return data
}

export const authorityMessages = {
  fa: 'تغییر نقش‌ها و دسترسی حساب مدیران فقط برای مدیر کل امکان‌پذیر است.',
  en: 'Only a super administrator can change roles or administrator account access.',
  ar: 'يمكن للمدير العام فقط تغيير الأدوار أو صلاحيات حسابات المديرين.',
}
